import globals from 'scoreboard/components/globals'
import _ from 'lodash'
import ObjectSelectorMenu from 'scoreboard/components/bootslide/object-selector-menu'

var AddDomainObjectEndpoint = ObjectSelectorMenu.Option.extend({

	selectorOptions: function(opt) {
		return {
			orgId: globals.orgId,
			section: this.section,
			// #28856 Allow to select from other projects
			showProjectSelector: true
		}
	},

	render: function () {
		return ObjectSelectorMenu.Option.prototype.render.apply(this, arguments)
	},

	select: function(node) {
		node = node || this.objectSelector.selected()
		this.add(node, this.objectSelector.selectedOrg())
	},

	remove: function () {
		ObjectSelectorMenu.Option.prototype.remove.apply(this, arguments)
		_.invokeMap([this.primaryButton], 'remove')
	}

})

export default AddDomainObjectEndpoint

AddDomainObjectEndpoint.__filename__ = 'components/bootslide/add-domain-object-endpoint.js'
